import styled from "styled-components";

type TextType = {
    color: string;
}

export const Container = styled.div`
    display: flex;
    flex: 1;
    height: 100%;
    flex-direction: column;
    padding: 0 16px;
    overflow: hidden;
`;

export const ContainerUsers = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    overflow: hidden;
`;

export const ContainerInputSearch = styled.div`
    display: flex;
    height: 70px;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    overflow: hidden;
`;

export const ContentInputSearch = styled.div`
    display: flex;
    width: 100%;
    padding: 0 10px;
`;
export const ContentLoading = styled.div`
    display: flex;
    height: 100px;
    align-items: center;
    justify-content: center;
`;
export const ContentTextNoResults = styled.div`
    display: flex;
    height: 70px;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;
export const Text = styled.span<TextType>`
    font-size: 15px;
    color: ${props => props.color};
    margin-top: -10px;
`;

export const Content = styled.div`
    display: flex;
    flex: 1;
    overflow: auto;
    flex-direction: column;

    &::-webkit-scrollbar {
        width: 5px;
        border-radius: 7px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        filter: brightness(80%);
    }

    &::-webkit-scrollbar-thumb:hover {
        filter: brightness(80%);
    }

`;

export const ContainerHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
`;

export const ContainerButtonEdit = styled.div`
    display: flex;
    overflow: hidden;
    height: 60px;
    min-height: 60px;
    max-height: 60px;
    align-items: center;
    justify-content: center;
`;

export const TextHeader = styled.span<TextType>`
    font-size: 18px;
    color: ${props => props.color};
    font-weight: bold;
    letter-spacing: 0.7px;
`;